import { render, staticRenderFns } from "./RowHeadingForm.vue?vue&type=template&id=2997ca16&scoped=true&"
import script from "./RowHeadingForm.vue?vue&type=script&lang=js&"
export * from "./RowHeadingForm.vue?vue&type=script&lang=js&"
import style0 from "./RowHeadingForm.vue?vue&type=style&index=0&id=2997ca16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2997ca16",
  null
  
)

export default component.exports